// src/components/IdleWarningBanner.jsx
// Shown for the final 2 minutes before an idle auto-logout (see
// AuthContext.jsx's IDLE_LOGOUT_MS/IDLE_WARNING_MS). Purely a UI nicety —
// no work is actually at risk of being lost, since step-boundary progress
// is already autosaved to Supabase independent of the browser session.
import { useAuth } from '../context/AuthContext'

import { T } from '../theme/theme'
export default function IdleWarningBanner() {
  const { idleWarning, stayLoggedIn, logout } = useAuth()
  if (!idleWarning) return null

  return (
    <div style={{
      position: 'fixed', top: 16, left: '50%', transform: 'translateX(-50%)',
      zIndex: 9999, background: T.s2, border: `1px solid ${T.or}`,
      borderRadius: '10px', padding: '14px 20px', display: 'flex',
      alignItems: 'center', gap: '16px', boxShadow: T.shl,
      fontFamily: "'Outfit',sans-serif", maxWidth: '92vw',
    }}>
      <span style={{ color: T.tx, fontSize: '13px' }}>
        You've been inactive for a while — you'll be signed out shortly for security.
        Any work you've completed up to this point is already saved.
      </span>
      <div style={{ display: 'flex', gap: '8px', flexShrink: 0 }}>
        <button onClick={stayLoggedIn} style={{
          padding: '8px 16px', borderRadius: '7px', border: 'none',
          background: T.prg, color: T.onpri,
          fontWeight: 700, fontSize: '13px', cursor: 'pointer',
        }}>
          Stay signed in
        </button>
        <button onClick={() => logout()} style={{
          padding: '8px 16px', borderRadius: '7px', border: `1px solid ${T.bd}`,
          background: 'transparent', color: T.lt,
          fontWeight: 600, fontSize: '13px', cursor: 'pointer',
        }}>
          Sign out now
        </button>
      </div>
    </div>
  )
}
